import type { MetricConfig } from '../types';
import registryJson from '../metrics-registry.json';

export const metricsRegistry: Record<string, MetricConfig> = Object.fromEntries(
  Object.entries(registryJson).map(([id, entry]) => [
    id,
    { id, ...(entry as Omit<MetricConfig, 'id'>) },
  ]),
);

export const getMetricConfig = (id: string): MetricConfig | undefined => metricsRegistry[id];
